export function generateRangeArray(from: number, to: number): number[] {
  return Array.from({ length: to - from + 1 }, (v, k) => k + from);
}

export function areArraysEqual<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((value, index) => value === arr2[index]);
}
